import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';

export default class ResumoController {
  public static async getSituacoesFreq(
    showLoading: boolean = true,
  ) {
    const route = 'getSituacoesFreq';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const situacoes: any[] = response.data.dataset.data;

      return situacoes;
    } catch (err) {
      const message = 'Não foi possível carregar as situações de frequência!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async saveResumoFreq(
    nrVinculo: string,
    date: string,
    rows: any[],
    showLoading: boolean = true,
  ) {
    const route = 'saveResumoFreq';
    const nrOrg: string = store.getters.user.nrorg;
    const cdOperador: string = store.getters.user.cdoperador;
    const nrPeriodo: string = store.getters.getNrperiodoApuracaoAtual;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        NRVINCULOM: nrVinculo,
        NRPERIODOAPURACAO: nrPeriodo,
        CDOPERADOR: cdOperador,
        DATE: date,
        rows,
      },
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      ExpectedError.throwResponseError(response);
    } catch (err) {
      let message = '';

      if (err instanceof ExpectedError) {
        message = err.message;
      } else {
        message = 'Não foi possível salvar as alterações!';
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }

    const message = 'Resumo de frequência salvo com sucesso!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

    return true;
  }

  public static async getResumoFreq(
    nrVinculo: string,
    date: string,
    showLoading: boolean = true,
  ) {
    const route = 'getResumoFreq';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      DATE: date,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const resumo: any[] = response.data.dataset.data;

      return resumo;
    } catch (err) {
      const message = 'Não foi possível carregar o resumo de frequência do dia!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async gestorCanEditResumo(
    showLoading = true,
  ) {
    const route = 'gestorCanEditResumo';
    const nrOrg: string = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const canEdit: boolean = response.data.dataset.data.canEdit;

      return canEdit;
    } catch (err) {
      const message = 'Não foi possível carregas as opções de resumo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
}
